// extracted by mini-css-extract-plugin
module.exports = {"Title":"WrapperColumn_Title___Lr76","Links":"WrapperColumn_Links__eeuOU","Item":"WrapperColumn_Item__rSUKq"};